import {NextPage} from "next";
import {useState} from "react";
import useProducts from "../../hooks/use-products";
import TrainingDownloadsLayout from "../../components/@bookstore/bookstore-training-downloads-layout";
import BookstoreProductGrid from "../../components/@bookstore/bookstore-product-grid";

const Downloads: NextPage = () => {
  const [pageIndex, setPageIndex] = useState(1);

  const { data, loading, error } = useProducts({
    conditions: [
      { code: 'status', namespace: '', value: 'ACTIVE' },
      { code: 'itemtype', namespace: '', value: 'Training Digital Download' }
    ],
    page: pageIndex - 1,
    size: 12,
  });

  if (typeof window === 'undefined') {
    return null;
  }

  const component = (children) => (
    <TrainingDownloadsLayout>
      {children}
      {/* language=CSS */}
      <style jsx>{`
        :global(.product-search-filter) {
          margin-top: 2rem;
          font-family: 'Volvo Novum', sans-serif;
          font-weight: 400;
          font-size: 14px;
          padding: 0 2rem;
        }
      `}</style>
    </TrainingDownloadsLayout>
  );

  if (loading || error) {
    return component(
      <p className="product-search-filter">
        Searching for products, please wait a minute.
      </p>
    );
  } else if (!data || data.products.content.length === 0) {
    return component(
      <p className="product-search-filter">
        Your search did not return any matching results. Please try a different
        search.
      </p>
    );
  } else {
    return component(
      <BookstoreProductGrid
        products={data.products}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
      />
    );
  }
}

export default Downloads;
